import Head from 'next/head'
import { useTranslation } from '@mc/i18n'
import { SITE_NAME, TWITTER_CARD, TWITTER_HANDLE } from 'libs/constants'

export const Meta = () => {
  const { t } = useTranslation('@mc/next')

  return (
    <Head>
      <title>{t('articlesCategories.meta.title')}</title>
      <meta
        content={t('articlesCategories.meta.description')}
        name='description'
      />
      <meta content={t('articlesCategories.meta.keywords')} name='keywords' />
      <meta content='https://www.masterclass.com/articles' property='og:url' />
      <meta content={SITE_NAME} property='og:site_name' />
      <meta content={t('articlesCategories.meta.title')} property='og:title' />
      <meta
        content={t('articlesCategories.meta.fbDescription')}
        property='og:description'
      />
      <meta content={TWITTER_CARD} name='twitter:card' />
      <meta content={TWITTER_HANDLE} name='twitter:site' />
      <meta
        content={t('articlesCategories.meta.title')}
        property='twitter:title'
      />
      <meta
        content={t('articlesCategories.meta.fbDescription')}
        name='twitter:description'
      />
      <meta
        content='https://www.masterclass.com/course-images/attachments/3YXutEJ6FhLmxV6jQb44opCD'
        name='twitter:image'
      />
    </Head>
  )
}
